import React from 'react';
import PropTypes from 'prop-types';
import Currency from './Currency';

/**
 * Displays currencies in the denomination of the current_pricing_options
 *
 * Since the frontend does not currently transact in any Money like class, we
 * must look to a sensible default. For historical reasons this component also
 * accepts a `className` and either an `amount` or `cents`.
 *
 * When possible it is advised that future display amounts be fetched from the
 * backend where we have greater control of formatting.
 */

// Maintains the signature and output of the old PriceSpan
const PriceSpan = ({ amount, cents, className, currency }) => {
  // Determine if we should divide cents or if they're already the base unit.
  // For example, KRW and JPY have no decimals so subunit_to_unit will be 1.
  const ratio =
    (typeof gon === 'object' ? gon.currency.subunit_to_unit : null) || 100;
  // eslint-disable-next-line eqeqeq
  const number = amount != null ? amount : cents / ratio;
  const currencyIsoCode =
    currency || (typeof gon === 'object' ? gon.currency.iso_code : null);
  return (
    <span className={className}>
      <Currency amount={number} currency={currencyIsoCode} />
    </span>
  );
};

PriceSpan.propTypes = {
  amount: (props, propName, componentName) => {
    if (props.cents == null && props.amount == null) {
      return new Error(
        `One of props 'cents' or 'amount' was not specified in '${componentName}'.`
      );
    }
  },
  cents: PropTypes.number,
  className: PropTypes.string,
};

export default PriceSpan;
